import React, {ReactNode} from 'react';
import EpiComponent from '@episerver/spa-core/EpiComponent';
import ContentRecommendationsBlockData from 'app/Models/Content/ContentRecommendationsBlockData';

export default class ContentRecommendationsBlock extends EpiComponent<ContentRecommendationsBlockData> {
  public render(): null | ReactNode {
    return <div className='alert alert-warning'>Content recommendations are not yet available.</div>;
  }
}
